module.exports = __webpack_public_path__ + "img/p_traditional.2fd30953.jpg";